module.exports = __webpack_public_path__ + "img/ec.94317bef.svg";